import { useJobStore } from "../../store/Jobs";
import { usePatientStore } from "../../store/Patient";
import { XCircle } from "lucide-react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { APP_BAR_COLORS } from "../../layout/layout-components/app-bar/app-bar-constants";
import { getStatusColor } from "@/dentlab/src/lib/utils/job-utils";
import { JobWithShare } from "@/lib/supabase/supabaseTypes";

export const JobTabs: React.FC = () => {
  const { pinnedJobs, unpinAllJobs, unpinJob } = useJobStore((state) => ({
    pinnedJobs: Object.values(state.pinnedJobs),
    unpinAllJobs: state.unpinAllJobs,
    unpinJob: state.unpinJob,
  }));

  const { patientName, patientsLookup } = usePatientStore((state) => ({
    patientName: state.patientName,
    patientsLookup: state.patientsLookup,
  }));

  const navigate = useNavigate();

  if (pinnedJobs.length === 0) {
    return null;
  }

  const handleJobClick = (job: JobWithShare) => {
    const url = `/client/${job.client_id}/job/${job.id}`;
    navigate(url);
  };

  const handleUnpinJob = (e: any, jobId: number | null) => {
    if (jobId) {
      unpinJob(jobId);
    }
  };

  return (
    <div className={`h-8 ${APP_BAR_COLORS.BACKGROUND}  pl-3.5 flex items-center`}>
      <div className="flex-1 flex items-center gap-2 overflow-x-auto hide-scrollbar">

        <div className="pinned-jobs-container flex-1 overflow-x-auto hide-scrollbar">
          <div className="flex items-center gap-1.5">
            {pinnedJobs.map((job) => (
              <div
                key={job.id}
                className="group flex items-center gap-1 px-2 h-6 text-xs rounded-md hover:bg-stone-300 bg-stone-200 cursor-pointer transition-colors whitespace-nowrap"
              >
                <div onClick={() => handleJobClick(job)} className="flex items-center gap-1">
                  <div className={`h-1.5 w-1.5 rounded-full ${job.status ? getStatusColor(job.status) : ""}`} />
                  <span className="font-medium">{job.code}</span>
                  {job.patient_id && (
                    <span className="text-gray-500 max-w-[80px] truncate">
                      {patientName(patientsLookup[job.patient_id])}
                    </span>
                  )}
                </div>
                <XCircle
                  className="w-3 h-3 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity"
                  onClick={(e: any) => handleUnpinJob(e, job.id)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {pinnedJobs.length > 1 && (
        <Tooltip title="Alle entpinnen">
          <button
            onClick={unpinAllJobs}
            className="ml-2 text-gray-400 hover:text-gray-600 flex items-center text-xs"
          >
            <span className="mr-1">Alle Aufträge entfernen</span>
            <XCircle className="w-3 h-3" />
          </button>
        </Tooltip>
      )}
    </div>
  );
};